import { Component, OnInit } from '@angular/core';
import { AuthControllerService } from '../Services/auth-controller.service';
import { DivisionService } from '../Services/division.service';
import { MyModalService } from '../Services/modal-service.service';
import { AuthService } from '../Services/auth.service';
import { Logininfo } from '../classes/Loginifo';

@Component({
  selector: 'app-company-related',
  templateUrl: './company-related.component.html',
  styleUrls: ['./company-related.component.css']
})
export class CompanyRelatedComponent implements OnInit {
  logininfo: Logininfo = this.auth.loginID;

  offices;
  office;
  officeName: string;
  officeAddr: string;

  postList;

  add_post;

  message_division: string;
  message_auth: string;
  error_division: string;
  error_auth: string;

  constructor(
    private AuthControll: AuthControllerService,
    private divisionService: DivisionService,
    private modal: MyModalService,
    public auth: AuthService
  ) { }

  ngOnInit() {
    this.divisionService.getDivisionList().subscribe(result => {
      this.offices = result;
    });
    this.getPostList();
    this.resetAdd();
  }


  //役職リスト読み込み
  getPostList() {
    this.AuthControll.getAuthList().subscribe(result => {
      Object.keys(result).forEach(function (key) {
        if (result[key].authority == null) {
          result[key].authority = {
            PersonalStatus: false,
            TeamStatus: false,
            AllStatus: false,
            EventCalendar: false,
            PersonalCalendar: false,
            AllCalendar: false,
            ClientList: false,
            ReservationList: false,
            ProcessList: false,
            Auth: "NONE",
          }
        };
      });
      this.postList = result;
      this.resetAdd();
    });

  }

  //保存
  save() {
    this.message_division = '';
    this.message_auth = '';
    this.error_division = '';
    this.error_auth = '';
    this.AuthControll.updateAuthList(this.postList).subscribe(res => {
      if (('error' in res) && res['error'] == 1) {
        this.error_auth = '権限の保存に失敗しました。';
      } else {
        this.message_auth = '権限を保存しました。';
      }
    });
    this.divisionService.updateDivisionList(this.offices).subscribe(res => {
      if (('error' in res) && res['error'] == 1) {
        this.error_division = '事業部の保存に失敗しました。';
      } else {
        this.message_division = '事業部を保存しました。';
      }
    });;
  }

  //役職追加
  addPost() {
    if (this.add_post != null) {
      this.AuthControll.insertAuthPost(this.add_post).subscribe(res => {
        this.getPostList();
      });
    }
  }

  resetAdd() {
    this.add_post = {
      authority_code: null,
      authority_name: '',
      authority: null,
    }
    this.add_post.authority = {
      PersonalStatus: false,
      TeamStatus: false,
      AllStatus: false,
      EventCalendar: false,
      PersonalCalendar: false,
      AllCalendar: false,
      ClientList: false,
      ReservationList: false,
      ProcessList: false,
      Auth: "NONE",
    }
  }

  //役職削除
  async delPost(post) {
    var delAuth = this.postList.filter((auth) => auth.authority_code == post);
    if (delAuth.length > 0) {
      const res = await this.modal.confirm('削除', '『' + delAuth[0].authority_name + '』を本当に削除してもよろしいですか？');
      if (!res) {
        return;
      }

      this.AuthControll.deleteAuthPost(delAuth[0].authority_code).subscribe(res => {
        this.getPostList();
      });
    }
  }

  //事業部登録
  add() {
    if (this.officeName != undefined && this.officeAddr != undefined) {
      var temp = {
        division_code: null,
        division_name: this.officeName,
        division_short_name: this.officeAddr
      };
      this.divisionService.insertDivision(temp).subscribe(res => {
        this.divisionService.getDivisionList().subscribe(result => {
          this.offices = result;
          this.officeName = undefined;
          this.officeAddr = undefined;
        });
      })
    }
  }

  //事業部削除
  async delete() {
    if (!!this.office) {
      let index = this.offices.findIndex(i => i.division_code == this.office);
      const res = await this.modal.confirm('削除', '『' + this.offices[index].division_name + '』を本当に削除してもよろしいですか？');
      if (!res) {
        return;
      }
      this.divisionService.deleteDivision(this.office).subscribe(res => {
        this.divisionService.getDivisionList().subscribe(result => {
          this.offices = result;
        });
      });
    }
  }


  //権限操作
  //２回クリックで解除
  cancel(post: any, event: any) {
    if (post.Auth == event.target.value) {
      post.Auth = 'NONE';
    }
  }

  //リストボックス操作
  prev() {
    if (!!this.office) {
      let index = this.offices.findIndex(i => i.division_code == this.office);
      if (index > 0) {
        let code = this.offices[index].division_code;
        this.offices[index].division_code = this.offices[index - 1].division_code;
        this.offices[index - 1].division_code = code;

        let temp = this.offices[index];
        this.offices[index] = this.offices[index - 1];
        this.offices[index - 1] = temp;
      }
    }
  }

  next() {
    if (!!this.office) {
      let index = this.offices.findIndex(i => i.division_code == this.office);
      if (index < this.offices.length - 1) {
        let code = this.offices[index].division_code;
        this.offices[index] = this.offices[index + 1].division_code;
        this.offices[index + 1].division_code = code;

        let temp = this.offices[index];
        this.offices[index] = this.offices[index + 1];
        this.offices[index + 1] = temp;
      }
    }
  }
}
